import { Listener } from './listener';
import { Subject } from './subject';

/**
 * Observable object with a stored value.
 *
 * @note See [../../../documentation/subjects.md] for additional information.
 */
export class BehaviorSubject<T> extends Subject<T> {
  private _value: T;

  get value(): T {
    return this._value;
  }
  set value(value: T) {
    this.next(value);
  }

  constructor(value: T) {
    super();
    this._value = value;
  }

  /** @inheritdoc */
  next(event: T): void {
    this._value = event;
    super.next(event);
  }

  /** @inheritdoc */
  subscribe(listener: Listener<T>): void {
    super.subscribe(listener);
    listener(this._value);
  }
}
